export default __webpack_public_path__ + "static/media/cnp19_4.ad961ead.png";